import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, catchError, map, of, tap, throwError } from 'rxjs';
import { ApiResponse } from '../../../../shared/dtos/api-response';
import { ApiError } from '../../../../shared/dtos/api-error';
import { ApplicationMapper } from '../models/application';
import type { Application } from '../models/application';
import { ApplicationsStore } from '../stores/applications.store';
import { INTERNAL_APPLICATIONS_ENDPOINT } from '../constants/endpoints';
import type { ApplicationSummary } from '../dtos/application';
import { startAuthenticatedPolling } from '../../../../shared/utils/authenticated-polling';

@Injectable({ providedIn: 'root' })
export class ApplicationsService {
  private readonly http = inject(HttpClient);
  private readonly applicationsStore = inject(ApplicationsStore);

  constructor() {
    startAuthenticatedPolling(() => this.getApplications());
  }

  /** Stub: loads applications when backend list endpoint is available */
  getApplications(): Observable<Application[]> {
    this.applicationsStore.setLoading();
    return this.http.get<ApiResponse<ApplicationSummary[]>>(INTERNAL_APPLICATIONS_ENDPOINT).pipe(
      map((resp) => ApplicationMapper.fromDtoList(resp.data)),
      tap((records) => this.applicationsStore.setRecords(records)),
      catchError((err: HttpErrorResponse) => {
        if (err.status === 404) {
          this.applicationsStore.setRecords([]);
          return of([]);
        }
        const body = err.error as ApiError | undefined;
        this.applicationsStore.setError(body?.message ?? 'Failed to load applications.');
        return throwError(() => body ?? { message: 'Failed to load applications.' });
      }),
    );
  }
}
